import React, { Component, ReactNode } from 'react';
import BaseModal from 'modules/Layout/component/Modal';
import InformationList from 'modules/Layout/component/InformationList';
import { Button } from 'reactstrap';
import Loader from 'modules/Layout/component/Loader';
import {
  addToastAction,
  AddToastAction,
  AddToastPayload
} from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
  deletePrivacyPolicyToastError,
  deletePrivacyPolicyToastSuccess
} from 'modules/Policy/toasts';
import { deletePP } from 'modules/Policy/repository';
import PrivacyPolicy from 'modules/Policy/model/PrivacyPolicy';

export interface DispatchProps {
  addToast: (payload: AddToastPayload) => AddToastAction;
}

export interface Props extends DispatchProps {
  onSuccess?: () => void;
  onError?: () => void;
}

export interface State {
  pp: PrivacyPolicy;
  open: boolean;
  deleting: boolean;
}

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  addToast: (payload) => dispatch(addToastAction(payload))
});

export class DeletePrivacyPolicyModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      pp: null,
      open: false,
      deleting: false
    };

    this.renderBody = this.renderBody.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.delete = this.delete.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  open(pp: PrivacyPolicy): void {
    this.setState({
      open: true,
      pp,
      deleting: false
    });
  }

  close(): void {
    this.setState({
      open: false
    });
  }

  renderBody(): ReactNode {
    const { pp, deleting } = this.state;

    const fields = [
      {
        label: 'Activation date:',
        value: pp.activation_date
      }
    ];

    return (
      <div>
        {deleting && <Loader />}
        <InformationList fields={fields} />
      </div>
    );
  }

  renderFooter(): ReactNode {
    const { deleting } = this.state;

    return (
      <div className="d-flex w-100 justify-content-between">
        <Button
          color="primary"
          disabled={deleting}
          onClick={this.close}
          className="mr-2"
        >
          Cancel
        </Button>
        <Button color="danger" disabled={deleting} onClick={this.delete}>
          Delete
        </Button>
      </div>
    );
  }

  async delete(): Promise<void> {
    const { onSuccess, onError, addToast } = this.props;
    const { pp } = this.state;

    try {
      this.setState({
        deleting: true
      });

      await deletePP(pp.id);

      this.close();

      if (onSuccess) {
        onSuccess();
      }

      addToast(deletePrivacyPolicyToastSuccess());
    } catch (error) {
      this.close();

      if (onError) {
        onError();
      }

      addToast(deletePrivacyPolicyToastError());
    }
  }

  render(): ReactNode {
    const { open, pp } = this.state;

    if (!pp) {
      return null;
    }

    return (
      <BaseModal
        isOpen={open}
        body={this.renderBody()}
        footer={this.renderFooter()}
        title="Do you want to delete privacy policy?"
        toggle={this.close}
        onClosed={this.close}
      />
    );
  }
}

export default connect<null, DispatchProps>(null, mapDispatch, null, {
  forwardRef: true
})(DeletePrivacyPolicyModal);
